// extracted by mini-css-extract-plugin
export var columnList = "_9u-0";